import React from "react";
import NotificationDropdown from "components/navbar/top/NotificationDropdown";
import ProfileDropdown from "components/navbar/top/ProfileDropdown";
import { Nav } from "react-bootstrap";
import NineDotMenu from "components/navbar/top/NineDotMenu";
import ThemeControlDropdown from "components/navbar/top/ThemeControlDropdown";

const TopNavRightSideNavItem = () => {
  return (
    <Nav
      navbar
      className="navbar-nav-icons ms-auto flex-row align-items-center"
      as="ul"
    >
      <ThemeControlDropdown />
      {/* TODO: Remove this once we have it ready */}
      {import.meta.env.VITE_REACT_APP_ENVIRONMENT !== "Production" && (
        <NotificationDropdown />
      )}
      <NineDotMenu />
      <ProfileDropdown />
    </Nav>
  );
};

export default TopNavRightSideNavItem;
